import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { getIssuesByContractor } from '../services/issues'

export function useContractorBadgeCounts() {
  const location = useLocation()
  const [jobsActionCount, setJobsActionCount] = useState(0)

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const issues = await getIssuesByContractor()
        const actionNeeded = issues.filter(
          i => i.status === 'acknowledged' || i.status === 'quote_approved'
        ).length
        setJobsActionCount(actionNeeded)
      } catch {
        // Silently fail - badges will show 0
      }
    }

    fetchCounts()
  }, [location.pathname])

  const getBadgeCount = (route: string): number => {
    if (route === '/jobs') return jobsActionCount
    return 0
  }

  return { getBadgeCount }
}
